﻿import { onEvent } from "./_dom.js";
import { setCookie } from "./cookie.js";

const kWorkspaceCookie = "td-wks";

function init(context, selector = ".v3-db-workspaces__button") {
	onEvent(context, selector, "v3-toolaction.menuclick", e => {
		const link = e.detail;
		const href = link.getAttribute("href");
		if (href[0] === "#") {
			const workspaceId = href.substring(1);
			if (!isNaN(+workspaceId)) {
				e.preventDefault();
				const l = location, p = l.pathname, ap = p.replace(/^(.*\/db\/[-\d]+)\/.*/i, "$1");
				setCookie(kWorkspaceCookie, workspaceId, { maxAge: 3E8, path: ap, secure: "auto" });
				let n;
				if ((n = p.lastIndexOf("/")) >= 0)
					l.href = p.substring(0, n) + "/default.aspx";
				else
					l.reload(true);
			}
		}
	});
}

export { init };